import {createStore, createEvent, Store, Event} from '@effector/effector'
import {batchEvent} from '../batch'
import {list, Signal} from '../h'

export const selectTab = createEvent<string | null>()

const selectedTab = createStore<string | null>(null).on(
  batchEvent(selectTab),
  (_, selected) => selected[selected.length - 1]
)

export type Tab = {
  name: string
  title: Store<string> | string
  content: () => void
}

export const registerTab = createEvent<Tab>()
const tabs = createStore<Tab[]>([]).on(
  batchEvent(registerTab),
  (list, tabs) => [...list, ...tabs]
)

export function Tabs(
  cb: (params: {
    selected: Store<boolean>
    select: Event<any>
    signal: Signal
    title: Store<string> | string
    content: () => void
    name: string
  }) => void
) {
  list({source: tabs, key: 'name'}, ({store, signal}) => {
    const {title, content, name} = store.getState()
    const selected = selectedTab.map(selected => selected === name)
    const select = selectTab.prepend<any>(() => name)
    cb({
      selected,
      select,
      signal,
      title,
      content,
      name
    })
  })
}
